module.exports = __webpack_public_path__ + "static/media/LBD About Us.626f6df8.mp4";